import RoutesCore from './Routes';
export * from './Paths';

export const Routes = RoutesCore;
